import { thanos26GetJson, thanos26PostJson } from "./thanos26Client";

const URL_TEMPLATES = "Templates";

export async function getTemplates(): Promise<any> {
    return thanos26GetJson(URL_TEMPLATES);
}

export async function setTemplates(body: any): Promise<any> {
    return thanos26PostJson(URL_TEMPLATES, {}, body);
}

export default { getTemplates, setTemplates };
